import cn from 'classnames';
import styles from './FlexRow.module.scss';
import { ReactNode } from 'react';

type FlexRowProps = {
  children: ReactNode;
  className?: string;
};

export function FlexRow({ children, className }: FlexRowProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return <div className={wrapperClassName}>{children}</div>;
}
